import React, { Fragment } from 'react';
import { TextField } from '@gerdau/hefesto';

import { BoldText, WarningText } from '../styles';
import { Container, VolumeContainer } from './styles';
import { ISelectedTableOrders, UpdateErrorMsgMap, UpdateErrorType } from '..';
import QuantityInput from '../../../../../../../../components/Purchase/QuantityInput';

interface IVolumeUpdate {
  loading: boolean;
  selectedItens: ISelectedTableOrders[];
  onChangeValue: (
    value: string,
    itemId: string,
    orderId: string,
    objKey: 'newVolume'
  ) => void;
  warningComponents: JSX.Element[] | null;
  hasUpdateError: boolean;
}

const UpdateVolume: React.FC<IVolumeUpdate> = ({
  loading,
  selectedItens,
  onChangeValue,
  warningComponents,
  hasUpdateError
}) => {
  return (
    <>
      <p>
        <BoldText>Ajuste no volume</BoldText>
      </p>
      <p>
        O novo valor do volume deve ser calculado com base no saldo restante e
        deve ser múltiplo de cada item.
      </p>
      {!hasUpdateError && warningComponents?.length
        ? warningComponents.map((component, index) => (
            <Fragment key={index}>{component}</Fragment>
          ))
        : null}
      {hasUpdateError && (
        <>
          {selectedItens.map((item) => {
            if (
              item.materials.some(
                (m) => m.errorType && m.errorType !== UpdateErrorType.DATE
              )
            ) {
              return (
                <Fragment key={item.orderNumber}>
                  <WarningText>
                    Para o pedido <strong>{item.orderNumber}</strong> {': '}
                    {item.materials.map((material) => {
                      if (material.errorType) {
                        return (
                          <div
                            key={material.id}
                            style={{ marginBottom: '1rem' }}
                          >
                            <span>
                              O item <strong>{material.description}</strong> não
                              pôde ser alterado porque{' '}
                              <strong>
                                {material.errorType === UpdateErrorType.ITEM &&
                                material.updateErrorMessage
                                  ? material.updateErrorMessage
                                  : UpdateErrorMsgMap.get(material.errorType)}
                              </strong>
                            </span>
                            <br />
                          </div>
                        );
                      }
                    })}
                  </WarningText>
                </Fragment>
              );
            }
          })}
          {selectedItens
            .flatMap((items) => items.materials)
            .some(
              (m) => m.errorType && m.errorType !== UpdateErrorType.DATE
            ) && (
            <WarningText>
              <strong>
                Selecione na tabela apenas o item que pode ser alterado.
              </strong>
            </WarningText>
          )}
        </>
      )}
      <Container>
        {selectedItens.map((item) => {
          return (
            <Fragment key={item.orderNumber}>
              <p>
                <BoldText>Pedido nᵒ {item.orderNumber}</BoldText>
              </p>
              {item.materials.map((material) => {
                return (
                  <Fragment key={material.id}>
                    <span>{material.description}</span>
                    <VolumeContainer>
                      <TextField
                        label="De"
                        name="initialVolume"
                        value={`${material.orderedQuantity.requestedQuantity.replace(
                          '.',
                          ','
                        )} ${material.orderedQuantity.requestedMeasureUnit}`}
                        readOnly
                      />
                      <QuantityInput
                        label="Para"
                        onChange={(value: string) =>
                          onChangeValue(
                            value,
                            material.id.toString(),
                            item.orderNumber,
                            'newVolume'
                          )
                        }
                        value={material.newVolume ?? ''}
                        measureUnit={material.measurement}
                        width="24"
                        disableInput={
                          loading ||
                          !material.changeAllowed ||
                          material.errorType === UpdateErrorType.QUANTITY ||
                          material.errorType === UpdateErrorType.STATUS ||
                          material.errorType === UpdateErrorType.ORDER_TYPE
                        }
                      />
                    </VolumeContainer>
                  </Fragment>
                );
              })}
            </Fragment>
          );
        })}
      </Container>
    </>
  );
};

export default UpdateVolume;
